import React from 'react';
import ReactDOM from 'react-dom';
import Router from './router'
import './index.css';


const RootDom = document.getElementById('root')

ReactDOM.render(
    <div>
        <Router />
    </div>,
    RootDom
)


// WEBPACK FOOTER //
// ./src/index.js